"function"!=typeof Promise&&require("promise-polyfill/dist/polyfill");


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/lib/polyfills/es6Promise.js
// module id = 1118
// module chunks = 106